import axios from "axios";
import store from "../store"

// todo bearer token
export default {
    createSubscription() {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription`,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    createSubscriptionTestAchats(payload) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription?for_groupbuy=AG000132`,
                data: payload,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    getSubscription(id, guid, withOptions = false) {
        let params = {};
        if(withOptions) params['withOptions'] = 1;

        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}`,
                params: params
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    getSubscriptionByCustomer(customerId, jwt) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription`,
                params: {
                    from_customer: customerId,
                    jwt: jwt,
                },
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    getSubscriptionByLead(lead) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription`,
                params: {
                    from_lead: lead
                },
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    createSubscriptionForAgent(agent, jwt, payload) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription`,
                params: {
                    for_agent: agent,
                    jwt: jwt
                },
                data: payload,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    createSubscriptionFromLoss(data) {
        const complete = data.complete ? '&complete=true' : '';
        let query = ''
        data.contractIds.map(id => {
            query += `&contracts[]=${id}`
        })

        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url:
                    `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription?loss=${store.state.comeback.customerId}&uuid1=${store.state.comeback.uuid1}&uuid2=${store.state.comeback.uuid2}` + complete + query,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    updateSubscription(payload) {
        return new Promise((resolve, reject) => {
            let id = store.state.subscription.id;
            let guid = store.state.subscription.guid;
            //payload['sponsor_customer_id'] = store.state.subscription.sponsorCustomId;
            if(payload['promo'] === undefined && store.state.subscription.promo) payload['promo'] = store.state.subscription.promo;
            if(payload['campaign'] === undefined && store.state.subscription.campaign) payload['campaign'] = store.state.subscription.campaign;
            axios({
                method: "patch",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}`,
                data: payload
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    addDocumentToContract(contractId, formData) {
        return new Promise((resolve, reject) => {
            let id = store.state.subscription.id;
            let guid = store.state.subscription.guid;

            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}/contracts/${contractId}/files`,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    getContractDocuments(contractId) {
        return new Promise((resolve, reject) => {
            let id = store.state.subscription.id;
            let guid = store.state.subscription.guid;

            axios({
                method: "get",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}/contracts/${contractId}/files`,

            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    confirmSubscription(id, guid, confirm = null) {
        let params = {}
        if(confirm) params['confirmation_guid'] = confirm;

        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}/confirm`,
                params: params
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
        });
    },
    proposeSubscription() {
        return new Promise((resolve, reject) => {
            let id = store.state.subscription.id;
            let guid = store.state.subscription.guid;

            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}/proposal`
            })
            .then(response => resolve(response.data))
            .catch(error => reject(error));
        });
    },
    cancelSubscription(id, guid, reason) {
        return new Promise((resolve, reject) => {
            axios({
                method: "put",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}/cancel?reason=${reason}&confirmationEmail=1`
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    createContract() {
        return new Promise((resolve, reject) => {
            let id = store.state.subscription.id;
            let guid = store.state.subscription.guid;

            axios({
                method: "post",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${id}/${guid}/contracts`,
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
    updateContract(id, payload) {
        let subscriptionId = store.state.subscription.id;
        let guid = store.state.subscription.guid;

        return new Promise((resolve, reject) => {
            axios({
                method: "patch",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${subscriptionId}/${guid}/contracts/${id}`,
                data: payload
            })
                .then(response => resolve(response.data))
                .catch(error => reject(error));
        });
    },
  deleteContract(id) {
    let subscriptionId = store.state.subscription.id;
    let guid = store.state.subscription.guid;

    return new Promise((resolve, reject) => {
      axios({
        method: "delete",
        url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/subscription/${subscriptionId}/${guid}/contracts/${id}`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },

    getDeliveryDate(params) {

        return new Promise((resolve, reject) => {
            axios({
                method: "get",
                url: `${process.env.INSCRIPTION_SERVICE_PUBLIC_PATH}/delivery-date`,
                params: params
            })
                .then(response => resolve(response.data.delivery_date))
                .catch(error => reject(error));
        });
    },
}



// WEBPACK FOOTER //
// ./src/services/inscriptionService.js